import api from './api';
import type {
  TenantAttendanceMetricsResponse,
  TenantOperationalCampaignsResponse,
  TenantPressureMetricsResponse,
  TenantUsageSummaryEvent,
} from '../types';

/**
 * Load the tenant-scoped live pressure metrics snapshot used for bootstrap and recovery.
 */
export async function fetchTenantPressureMetrics(): Promise<TenantPressureMetricsResponse> {
  const response = await api.get('/api/tenant/metrics/pressure/');
  return response.data as TenantPressureMetricsResponse;
}

/**
 * Load the tenant-scoped operational campaign posture used by shell drilldowns.
 */
export async function fetchTenantOperationalCampaigns(): Promise<TenantOperationalCampaignsResponse> {
  const response = await api.get('/api/tenant/metrics/campaigns/');
  return response.data as TenantOperationalCampaignsResponse;
}

/**
 * Load the tenant-scoped live attendance metrics snapshot used for bootstrap and recovery.
 */
export async function fetchTenantAttendanceMetrics(): Promise<TenantAttendanceMetricsResponse> {
  const response = await api.get('/api/tenant/metrics/attendance/');
  return response.data as TenantAttendanceMetricsResponse;
}

/**
 * Load the tenant-scoped live usage metrics snapshot used for bootstrap and recovery.
 */
export async function fetchTenantUsageMetrics(): Promise<TenantUsageSummaryEvent> {
  const response = await api.get('/api/tenant/metrics/usage/');
  return response.data as TenantUsageSummaryEvent;
}
